import { Facebook, Link2, Download, MessageCircle, Share2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { toast } from "sonner";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2H21.5l-7.5 8.57L22.8 22h-6.9l-5.4-7.06L4.3 22H1l8.03-9.18L.6 2h7.07l4.88 6.45L18.244 2zm-1.21 18h1.9L6.98 3.9H4.94L17.03 20z" /></svg>
);

export function ReunionShare({ listing }) {
  const { t } = useLanguage();
  const shareUrl = `${BASE}/share/reunion/${listing.id}`;
  const text = `${t("rsh_text")} ${listing.title}`;
  const enc = encodeURIComponent;
  const links = [
    { id: "facebook", label: "Facebook", icon: <Facebook size={15} />, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}`, cls: "bg-[#1877F2] hover:bg-[#166FE5] text-white" },
    { id: "x", label: "X", icon: <XIcon />, href: `https://twitter.com/intent/tweet?url=${enc(shareUrl)}&text=${enc(text)}`, cls: "bg-black hover:bg-slate-800 text-white" },
    { id: "whatsapp", label: "WhatsApp", icon: <MessageCircle size={15} />, href: `https://wa.me/?text=${enc(`${text} ${shareUrl}`)}`, cls: "bg-[#25D366] hover:bg-[#1EBE5A] text-white" },
  ];
  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); toast.success(t("rsh_copied")); }
    catch { toast.error("Could not copy"); }
  };
  return (
    <section className="bg-white rounded-2xl border border-emerald-200 p-6" data-testid="reunion-share">
      <h3 className="font-display font-bold text-[#12234A] flex items-center gap-2"><Share2 size={18} className="text-emerald-600" /> {t("rsh_title")}</h3>
      <p className="text-sm text-slate-500 mt-0.5">{t("rsh_sub")}</p>
      <img src={`${BASE}/listings/${listing.id}/reunion-card.png?v=${encodeURIComponent(listing.reunion_story?.updated_at || "")}`} alt="Reunion card"
        data-testid="reunion-card-preview" className="mt-4 w-full rounded-xl border border-slate-200 aspect-[1200/630] object-cover bg-slate-100" />
      <div className="flex flex-wrap gap-2 mt-4">
        {links.map((l) => (
          <a key={l.id} href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`reunion-share-${l.id}`}
            className={`inline-flex items-center gap-2 h-10 px-4 rounded-xl text-sm font-semibold transition-colors ${l.cls}`}>{l.icon} {l.label}</a>
        ))}
        <button onClick={copy} data-testid="reunion-share-copy" className="inline-flex items-center gap-2 h-10 px-4 rounded-xl text-sm font-semibold border border-slate-200 text-[#12234A] hover:border-[#F5551E] transition-colors"><Link2 size={15} /> {t("rsh_copy")}</button>
        <a href={`${BASE}/listings/${listing.id}/reunion-card.png?download=1`} download data-testid="reunion-share-download"
          className="inline-flex items-center gap-2 h-10 px-4 rounded-xl text-sm font-semibold border border-slate-200 text-[#12234A] hover:border-[#F5551E] transition-colors"><Download size={15} /> {t("rsh_download")}</a>
      </div>
    </section>
  );
}
